import { render } from "./TagConsentTagDetailView.vue?vue&type=template&id=243bd0ba&scoped=true"
import script from "./TagConsentTagDetailView.vue?vue&type=script&lang=js"
export * from "./TagConsentTagDetailView.vue?vue&type=script&lang=js"

import "./TagConsentTagDetailView.vue?vue&type=style&index=0&id=243bd0ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243bd0ba"]])

export default __exports__